export const ERROR_CODE_HEADER = 'X-Error-Code';

// Pure (no openapi-fetch import) so it can be unit-tested under CRA's Jest, which
// cannot transform the ESM client. The fetch middleware in api.ts calls it: the
// backend sends `{"detail": ...}` plus the machine-readable code in a header, but
// openapi-react-query mutations reject with the parsed body only — so the code is
// copied into the body as `error_code` before anyone sees the response.
export async function attachErrorCode(response: Response): Promise<Response | undefined> {
  if (response.ok) return undefined;
  const code = response.headers.get(ERROR_CODE_HEADER);
  if (!code) return undefined;
  let body: unknown;
  try {
    body = await response.clone().json();
  } catch {
    return undefined;
  }
  if (!body || typeof body !== 'object' || Array.isArray(body)) return undefined;
  return new Response(JSON.stringify({ ...(body as Record<string, unknown>), error_code: code }), {
    status: response.status,
    statusText: response.statusText,
    headers: new Headers(response.headers),
  });
}
